import React from 'react'
import classNames from 'classnames'

import { createStyles, WithStyles, withStyles, Theme } from '@material-ui/core/styles'
import { Grid, Typography, LinearProgress } from '@material-ui/core'
import { LinearProgressProps } from '@material-ui/core/LinearProgress'

interface Props {
  totalQuestions: number
  currentQuestion: number
  answeredQuestions: number
  color?: LinearProgressProps['color']
}

const styles = (theme: Theme) => createStyles({
  root: {
    padding: theme.spacing() * 2,
  },
  label: {
    marginLeft: theme.spacing() * 2,
  },
  rounded: {
    borderRadius: 2,
    backgroundColor: theme.palette.grey[100],
  },
  barColorSecondary: {
    backgroundColor: theme.palette.grey[400],
  },
  zeroBar: {
    transform: 'scaleX(.02) !important',
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const QuizProgressBar: React.SFC<InjectedProps> = ({
  totalQuestions,
  currentQuestion,
  answeredQuestions,
  classes,
  color,
}) => (
  <Grid container alignItems="center" className={classes.root}>
    <Grid item xs>
      <LinearProgress
        color={color || 'secondary'}
        variant="determinate"
        value={100 * answeredQuestions / totalQuestions}
        classes={{
          bar: classNames({ [classes.zeroBar]: !answeredQuestions }),
          root: classes.rounded,
          barColorSecondary: classes.barColorSecondary,
        }}
      />
    </Grid>
    <Grid item>
      <Typography align="center" color="textSecondary" variant="body1" className={classes.label}>
        {currentQuestion} / {totalQuestions}
      </Typography>
    </Grid>
  </Grid>
)

export default withStyles(styles)(QuizProgressBar)
